import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export default function CheckIcon(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.32897 13.2295L4.43731 10.3378C4.11231 10.0128 3.5873 10.0128 3.2623 10.3378C2.9373 10.6628 2.9373 11.1878 3.2623 11.5128L6.74564 14.9962C7.07064 15.3212 7.59564 15.3212 7.92064 14.9962L16.7373 6.17949C17.0623 5.85449 17.0623 5.32949 16.7373 5.00449C16.4123 4.67949 15.8873 4.67949 15.5623 5.00449L7.32897 13.2295Z"
        fill="currentColor"
      />
    </svg>
  );
}
